import angular from 'angular';
import _ from 'lodash';

/**
 * @typedef {object} RegionGroup
 * @property {string} fullName
 * @property {string} shortName
 * @property {[number]} regionIds - регионы, входящие в группу
 */

/**
 * @memberOf RegionIds
 * @type {number[]}
 */
const newBuildingRegions = window.newobject_allowed_location_ids;

/**
 * @memberOf RegionIds
 */
const REGIONS = {
  MOSCOW: 1,
  MO: 4593,
  SPB: 2,
  LO: 4588,
};

/**
 * @memberOf RegionIds
 * @type {Object<string,RegionGroup>}
 */
const GROUPS = [{
  fullName: 'Москва и область',
  shortName: 'Москва и МО',
  regionIds: [
    REGIONS.MOSCOW,
    REGIONS.MO,
  ]
}, {
  fullName: 'Санкт-Петербург и область',
  shortName: 'Санкт-Петербург и ЛО',
  regionIds: [
    REGIONS.SPB,
    REGIONS.LO,
  ]
}];

export default angular.module('cian.newbuild.filter.regionIds', [])
  .constant('RegionIds', {
    REGIONS,
    GROUPS,
    newBuildingRegions,
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/region-ids.service.js